// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var CaretakersService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function CaretakersService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get caretakers list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CaretakersService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "condo-structures/caretakers-list", params);
    };
    /**
     * Get an exportation file of caretakers
     *
     * @since 1.0.0
     */
    CaretakersService.prototype.getExport = function (start, limit, sort, sortVersus, search) {
        var _this = this;
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'condo-structures/caretakers-list-export', params, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get all caretakers of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    CaretakersService.prototype.getCaretakers = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/caretakers")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    CaretakersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CaretakersService_Factory() { return new CaretakersService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: CaretakersService, providedIn: "root" });
    return CaretakersService;
}());
export { CaretakersService };
